import {Platform} from 'react-native';
import {getBottomSpace} from 'react-native-iphone-screen-helper';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  flex: 1;
  padding: 0 24px;
`;

export const Form = styled.View`
  height: ${RFValue(50)}px;
  margin-bottom: ${RFValue(6)}px;
`;

export const InputContainer = styled.View`
  margin: 0 -24px;
  padding: 0 24px;
  margin-top: ${RFValue(12)}px;
  padding-top: ${RFValue(12)}px;
  margin-bottom: ${RFValue(12)}px;
  border-top-width: 1px;
  border-top-color: ${({theme}) => theme.colors.border2};
  border-style: solid;
`;
export const InputGroup = styled.View``;

export const StationsList = styled.ScrollView`
  margin: 0 -24px;
`;

export const InputLabel = styled.Text`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.medium};
  margin-bottom: ${RFValue(6)}px;
`;

export const InputFooter = styled.View`
  flex-direction: row;
  margin-bottom: ${RFValue(12)}px;
  align-items: center;
  justify-content: space-between;
`;

export const InputFooterTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(12)}px;

  color: ${({theme}) => theme.colors.blue};
`;

export const Plate = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  text-transform: uppercase;
  color: ${({theme}) => theme.colors.blue};
`;

export const PlateRemove = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.blue};
  border-style: solid;
`;

export const PlateRemoveText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.blue};
`;

export const Footer = styled.View`
  padding: 0 24px;
  padding-top: ${RFValue(6)}px;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? 0
    : RFValue(20)}px;
`;

export const CouponAlert = styled.View`
  margin-top: ${RFValue(12)}px;
  padding: ${RFValue(8)}px ${RFValue(12)}px;
  background: ${({theme}) => theme.colors.green_light};
  border-radius: ${RFValue(8)}px;
`;

export const CouponAlertText = styled.Text`
  color: ${({theme}) => theme.colors.black};
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(10)}px;
`;

export const CouponAlertTextBold = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
`;
